<template>
  <div>
    <h3>{{ $t("pages.datasetList.sidebar.title") }}</h3>
    <a
      href="#menu-categories"
      :class="['menu-toggle-button', { 'menu-toggle-button--open': showMenu }]"
      @click="handleToggleMenu"
    >
      {{ menuLabel }}
      <i class="el-icon-caret-bottom" />
    </a>
    <el-menu
      id="menu-categories"
      :class="['menu', { 'menu--open': showMenu }]"
      default-active="1"
      ref="menuCategories"
    >
      <el-menu-item index="1" class="menu-item" @click="addCategory(null)">{{
        $t("pages.datasetList.sidebar.allCategories")
      }}</el-menu-item>
      <el-menu-item
        v-for="(category, index) in categories"
        :key="category.name"
        :index="`${index + 2}`"
        class="menu-item"
        @click="addCategory(category.name)"
        >{{ category.name }} ({{ category.count }})</el-menu-item
      >
    </el-menu>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { prettyCollapse } from "@/helpers/CssHelpers";

export default {
  props: ["categories"],
  data() {
    return {
      showMenu: false
    };
  },
  computed: {
    ...mapState("datasets", ["currentCategory"]),
    currentCategoryCount() {
      return this.$store.getters["datasets/getCurrentCategoryCount"](
        this.categories
      );
    },
    menuLabel() {
      return this.currentCategory
        ? `${this.currentCategory} ${this.currentCategoryCount}`
        : this.$t("pages.datasetList.sidebar.allCategories");
    }
  },
  methods: {
    addCategory(category) {
      this.$store.dispatch("datasets/selectCategory", category);
      this.toggleMenu();
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
      prettyCollapse(
        this.$refs.menuCategories,
        this.showMenu ? "open" : "close"
      );
    },
    handleToggleMenu(event) {
      event.preventDefault();
      this.toggleMenu();
    }
  }
};
</script>

<style lang="scss" scoped>
h3 {
  margin: 0 0 12px;
  font-weight: normal;
  font-size: 12px;
  text-transform: uppercase;
  text-align: left;
  color: $--color-text-light;
  @include media("<navbar-sm") {
    display: none;
  }
}

.menu-toggle-button {
  margin: 0;
  display: none;
  position: relative;
  color: $--color-primary;
  transition: margin 0.3s ease;
  @include media("<navbar-sm") {
    padding-right: 40px;
    padding-bottom: 10px;
    display: block;
  }

  .el-icon-caret-bottom {
    display: none;
    transition: transform 0.3s ease;
    @include media("<navbar-sm") {
      display: inline-block;
      vertical-align: middle;
      position: relative;
      top: -1px;
    }
  }
}

.menu-toggle-button--open {
  margin-bottom: rem(10);
  .el-icon-caret-bottom {
    transform: rotate(180deg);
  }
}

.menu {
  padding: 0 20px 30px;
  border-right: none;
  @include media("<navbar-sm") {
    padding: 0;
    height: 0;
    transition: height 0.3s ease;
    overflow: hidden;
  }
}

.menu-item {
  padding: 5px 0 !important;
  height: auto;
  line-height: 1.4;
  transition: 0.1s ease;
  transition-property: padding color;
  color: $--color-text;
  cursor: pointer;
  @include media("<navbar-sm") {
    padding-top: 7px !important;
    padding-bottom: 7px !important;
  }

  &:hover {
    text-decoration: underline;
    background: transparent;
    color: $--text-primary;
  }

  &:focus {
    background: transparent;
  }

  &:before {
    content: "";
    width: 0;
    height: em(20, 14);
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    transition: width 0.1s linear;
    background: $--color-purple;
  }

  &.is-active {
    padding-left: 12px !important;
    font-weight: bold;
    color: $--color-purple;
    @include media("<navbar-sm") {
      padding-left: 0 !important;
    }
    &:before {
      width: 2px;
      @include media("<navbar-sm") {
        display: none;
      }
    }
  }
}
</style>
